import axios, { type AxiosRequestConfig } from 'axios';
import { getLocalStorage } from './localstorage';

export const getHeaders = (persona = null) => {
  const tokens = getLocalStorage('tokens');
  const PA_API_CLIENT = import.meta.env.PA_API_CLIENT;
  const PA_API_KEY = import.meta.env.PA_API_KEY;
  const PA_API_CONSUMER = import.meta.env.PA_API_CONSUMER;

  // tokens is already parsed by getLocalStorage, handle both string and object
  const parsedTokens = typeof tokens === 'string' ? JSON.parse(tokens) : tokens;

  const personaHeader = persona
    ? {
        'persona-name': persona.name
      }
    : {};
  return {
    'api-client': PA_API_CLIENT,
    Authorization: `Bearer ${parsedTokens?.access_token || ''}`,
    'api-key': PA_API_KEY,
    'api-consumer': PA_API_CONSUMER,
    ...personaHeader
  };
};

export const apiCallHandler = async ({ config }: { config: AxiosRequestConfig }) => {
  const apiConfig = {
    ...config,
    headers: {
      ...config.headers,
      clientKey: import.meta.env.PA_CLIENT_KEY || ''
    }
  };
  try {
    const response = await axios.request(apiConfig);
    return { error: false, data: response.data };
  } catch (e: unknown) {
    return { error: true, data: (e as { response?: unknown }).response };
  }
};

export const customLogger = (message: string, data?: unknown) => {
  const logType =
    data && typeof data === 'object' && 'logType' in data
      ? String((data as Record<string, unknown>).logType)
      : 'log';
  const env = import.meta.env.PA_ENV_NAME as string;
  if (env !== 'prod' && env !== 'uat') {
    console[logType as 'log' | 'warn' | 'error'](message, data);
  }
};
